import React from 'react';
import { connect } from 'react-redux'
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { hideGlobalMessage } from '../actions/environmentActions';

class Modal extends React.Component {
 
    render() {

        const actions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.props.hideGlobalMessage}
            />
        ];

        return (
            <Dialog
                title="Message"
                actions={actions}
                modal={false}
                open={this.props.openGlobalMessage}
            >
                <p>{this.props.globalMessage}</p>
            </Dialog> 
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        hideGlobalMessage: () => {
            dispatch(hideGlobalMessage());
        }
    }
}

function mapStateToProps(state) {

    const { openGlobalMessage, globalMessage } = state.thisApp.environment;
   
    return {
        openGlobalMessage,
        globalMessage
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Modal);


// WEBPACK FOOTER //
// ./src/Components/Modal.js